/**
 * @description 值班排班管理 API 接口
 * @author Zhao Wang
 * @date 2026-03-16
 */

import config from "@/config"
import http from "@/utils/request"

export default {
	/**
	 * 排班记录 CRUD 接口
	 */
	duty: {
		url: `${config.HNYJ_URL}/api/v1/admin/duty`,
		name: "排班记录接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	/**
	 * 排班记录分页查询接口
	 */
	dutyPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/duty/page`,
		name: "分页查询排班记录",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	dutyList: {
		url: `${config.HNYJ_URL}/api/v1/admin/duty/schedule/list`,
		name: "排班列表记录",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
}
